<template>
  <div class="every-player-counts-video">
    <video-player :options="videoOptions" />
  </div>
</template>

<script>
import VideoPlayer from "@/components/video-player/VideoPlayer.vue";

export default {
  name: "EveryPlayerCountsVideo",
  components: {
    "video-player": VideoPlayer
  },
  data() {
    return {
      videoOptions: {
        autoplay: false,
        controls: true,
        muted: false,
        fill: true,
        loop: true,
        poster:
          "https://f001.backblazeb2.com/file/ballstar/every-player-counts-poster.png",
        sources: [
          {
            src:
              "https://f001.backblazeb2.com/file/ballstar/ballstar-every-player-counts.mp4",
            type: "video/mp4"
          }
        ]
      }
    };
  }
};
</script>
<style>
.every-player-counts-video .vjs-poster {
  background-size: 99% !important;
}

.every-player-counts-video .vjs-big-play-button {
  left: 45%;
  top: 40%;
}
</style>
